import { render, staticRenderFns } from "./AlertsComponent.vue?vue&type=template&id=f259b1fe&scoped=true"
import script from "./AlertsComponent.vue?vue&type=script&lang=js"
export * from "./AlertsComponent.vue?vue&type=script&lang=js"
import style0 from "./AlertsComponent.vue?vue&type=style&index=0&id=f259b1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f259b1fe",
  null
  
)

export default component.exports